import {MainPage} from './container';

export {
	MainPage,
};
